import { render, staticRenderFns } from "./TrainingWatchLiveBanner.vue?vue&type=template&id=2f9bfc12&scoped=true"
import script from "./TrainingWatchLiveBanner.vue?vue&type=script&lang=js"
export * from "./TrainingWatchLiveBanner.vue?vue&type=script&lang=js"
import style0 from "./TrainingWatchLiveBanner.vue?vue&type=style&index=0&id=2f9bfc12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9bfc12",
  null
  
)

export default component.exports